export function baseMethods() {
  // 微信和支付宝
  function is_weixn() {
    const ua = navigator.userAgent.toLowerCase();
    const micromessenger = ua.match(/MicroMessenger/i);
    const alipayclient = ua.match(/AlipayClient/i);
    if (micromessenger && micromessenger.length) {
      return true;
    } else if (alipayclient && alipayclient.length) {
      return true;
    } else {
      return false;
    }
  }
  function isPhone() {
    const u = navigator.userAgent,
      app = navigator.appVersion;
    const isAndroid = u.indexOf('Android') > -1 || u.indexOf('Linux') > -1; //g
    const isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
    if (isAndroid) {
      //这个是安卓操作系统
      return 'Android';
    }
    if (isIOS) {
      return 'IOS';
      //这个是ios操作系统
    }
    return 'PC';
  }

  /** 转62进制 */
  function toBase62(val: number) {
    const base = '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ';
    const ben = base.length;
    const arr = [];
    while (val > 0) {
      arr.push(base[val % ben]);
      val = Math.floor(val / ben);
    }
    return arr.reverse().join('');
  }

  return {
    is_weixn,
    isPhone,
    toBase62,
  };
}
